module.exports = __webpack_public_path__ + "static/media/_MIC2725.thumbnail.abf7cfce.png";